import * as React from 'react';
import { NavigateFunction } from 'react-router';

export const navigationRef = React.createRef<NavigateFunction | undefined>();

export const globalNavigate = (path) => {
  if (navigationRef.current) {
    navigationRef.current(path);
  } else {
    console.warn('Navigation function is not ready yet');
  }
};
